// src/PublicRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';

function PublicRoute({ children }) {
  const token = localStorage.getItem("access_token");
  return token ? <Navigate to="/auth" /> : children;
}

export default PublicRoute;